"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var JackpotPlayerTagEditor = /** @class */ (function (_super) {
    __extends(JackpotPlayerTagEditor, _super);
    function JackpotPlayerTagEditor(props) {
        return _super.call(this, props) || this;
    }
    JackpotPlayerTagEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            usr_player_tag_id: 0,
            usr_player_tag_title: ""
        }, function () {
            _this.props.state.setExtBreadCrumbPath(["\u041C\u0435\u0442\u043A\u0438 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 - [" + _this.props.rootRecord.title + "]", "Создание метки заблокированного игрока"]);
        });
        this.doReSetRules();
    };
    JackpotPlayerTagEditor.prototype.doReSetRules = function () {
        this.setState({
            usr_player_tag_rules: { isError: false }
        });
    };
    JackpotPlayerTagEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.usr_player_tag_id <= 0) || (this.state.usr_player_tag_title.length === 0)) {
            this.setState({ usr_player_tag_rules: { isError: true, errorMessage: "Метка не выбрана!" } });
            return false;
        }
        return true;
    };
    JackpotPlayerTagEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                usr_player_tag_id: this.state.usr_player_tag_id,
                bonus_jackpot_id: this.props.rootRecord.key,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Метка игроков джекпота добавлена!");
            });
        }
    };
    JackpotPlayerTagEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    JackpotPlayerTagEditor.prototype.getFormTitle = function () {
        return "Новая метка игроков джекпота";
    };
    JackpotPlayerTagEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 250 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Метка пользователя", placeholder: "Выберите метку пользователя" }, value: {
                    key: this.state.usr_player_tag_id,
                    value: this.state.usr_player_tag_title
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        usr_player_tag_id: newVal.key,
                        usr_player_tag_title: newVal.value,
                        usr_player_tag_rules: { isError: false }
                    });
                }, items: this.props.availPlayerTags, required: true, rules: this.state.usr_player_tag_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: false, title: { btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this) })));
    };
    return JackpotPlayerTagEditor;
}(React.Component));
exports.default = JackpotPlayerTagEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_jackpots/ui/component/player_tags/JackpotPlayerTagEditor.tsx
// module id = 2346
// module chunks = 0